/**
 * Created by Andrey Popov on 10.11.2021
 */

const BundlesExplorer = function (atlasAnalyzer, tab) {
    this.atlasAnalyzer = atlasAnalyzer;

    cleverapps.EventEmitter.call(this);

    this.loadedBundles = Object.keys(cleverapps.bundleLoader.handles);

    this.selectedItem = undefined;
    this.selectedTab = tab || "Main";
    this.itemsFilter = "";

    this.rebuildBundlesList();
};

BundlesExplorer.prototype = Object.create(cleverapps.EventEmitter.prototype);
BundlesExplorer.prototype.constructor = BundlesExplorer;

BundlesExplorer.prototype.rebuildBundlesList = function () {
    const bundlesWithImages = cleverapps.createSet(Object.keys(bundles).filter((name) => {
        const bundle = bundles[name];
        return bundle.meta.virtualDebugBundle || bundle.listUrls().some((virtualUrl) => {
            const url = virtualUrl && virtualUrl.getUrl();
            return typeof url === "string" && url.indexOf(".png") !== -1;
        });
    }));
    
    this.items = Object.keys(bundles).filter((name) => {
        if (BundlesExplorer.SKIP_BUNDLES_WITH_PREFIXES.filter((prefix) => name.indexOf(prefix) !== -1).length > 0) {
            return false;
        }

        if (this.itemsFilter && !name.includes(this.itemsFilter)) {
            return false;
        }

        const bundle = bundles[name];

        if (this.selectedTab === "Debug" && !bundle.meta.debug && !bundle.meta.virtualDebugBundle) {
            return false;
        }

        if (this.selectedTab !== "Debug" && (bundle.meta.debug || bundle.virtual || bundle.meta.virtualDebugBundle)) {
            return false;
        }

        const isEpisode = name.startsWith("episode_") && Number.isInteger(Number.parseInt(name.split("_")[1]));
        if (this.selectedTab === "Episodes" && !isEpisode) {
            return false;
        }
        if (this.selectedTab !== "Episodes" && isEpisode) {
            return false;
        }

        return (bundle.injectTo || [name]).some((name) => bundlesWithImages[name]);
    });

    if (this.selectedTab === "Episodes") {
        this.items.sort((a, b) => Number.parseInt(a.split("_")[1]) - Number.parseInt(b.split("_")[1]));
    }

    this.trigger("rebuildItems");
};

BundlesExplorer.prototype.selectItem = function (tab, texture, frame) {
    if (tab) {
        this.selectedTab = tab;
        this.trigger("selectedTabChanged", tab);
    }

    if (texture) {
        this.selectedItem = texture;
        this.trigger("selectionChanged", tab, texture, frame);
    }

    cleverapps.setUrlHash({ atlasAnalyzer: true, tab, bundleName: texture });
};

BundlesExplorer.prototype.onTabChanged = function (tab) {
    this.selectedTab = tab;
    this.rebuildBundlesList();
    cleverapps.setUrlHash({
        atlasAnalyzer: true, tab: this.selectedTab, bundleName: undefined, frame: undefined 
    });
};

BundlesExplorer.prototype.moveDown = function () {
    let index = 0;
    if (this.selectedItem) {
        let selectedItemIndex = this.items.indexOf(this.selectedItem);
        if (selectedItemIndex !== this.items.length - 1) {
            index = ++selectedItemIndex;
        }
    }

    this.selectItem(undefined, this.items[index]);
};

BundlesExplorer.prototype.moveUp = function () {
    let index = 0;
    if (this.selectedItem) {
        let selectedItemIndex = this.items.indexOf(this.selectedItem);
        if (selectedItemIndex !== 0) {
            index = --selectedItemIndex;
        }
    }

    this.selectItem(undefined, this.items[index]);
};

BundlesExplorer.prototype.setFilter = function (input) {
    this.itemsFilter = input;
    this.rebuildBundlesList();
};

BundlesExplorer.SKIP_BUNDLES_WITH_PREFIXES = [
    "simple_background_icon_"
];